module.exports = __webpack_public_path__ + "img/delete-hover.d0d64544.svg";